import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import {
  clickAddOutlet,
  clickCreateOutlet,
  search,
} from 'actions/outletPages/list';
import { Field, isDirty, reduxForm } from 'redux-form';
import { ActionBarWrapper } from 'components/wrappers/pages';
import { askConfirmAction } from 'actions/confirm-action';
import * as clevertapOutletsList from 'clevertap/outlets/list';
import MenuTitle from 'components/MenuTitle';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    const { outletSlots, usedOutletSlots } = this.props.data.outletPages.list;
    const { isTrial, isMokaPayUser } = this.props.data;

    return (
      <div>
        <MenuTitle menuTitle="Outlet" />
        <div className="col-sm-6 hidden-xs col-md-6 action-outlet">
          <span className="pull-right">
            {usedOutletSlots && (isTrial || isMokaPayUser) && (
              <button
                className={`btn btn-default no-outline ${styles['btn-outlet']}`}
              >
                Outlet: {usedOutletSlots}
              </button>
            )}
            {outletSlots && (!isTrial && !isMokaPayUser) && (
              <button
                className={`btn btn-default no-outline ${styles['btn-outlet']}`}
              >
                Outlet: {usedOutletSlots} out of {outletSlots}
              </button>
            )}
            <button
              className="btn btn-primary"
              onClick={this._onClickCreateOrAddButtonLabel}
            >
              {this._createOrAddButtonLabel()}
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="row">
            <div className="col-sm-3 col-md-3 col-xs-12 search-outlet">
              <Field
                component={SearchBar}
                placeholder="Search"
                name="keyword"
                className="searchbar-outletlist"
                onChange={this._onChangeKeyword}
              />
            </div>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onChangeKeyword = (event, newValue) => {
    this.props.dispatch(search({ q: newValue }));
  };

  /**
   * Create outlet: if outlet quota > current active outlet. Will show form
   * @private
   */
  _onClickCreateOutlet = () => {
    const {
      dispatch,
      data: { isDirtyForm },
    } = this.props;
    if (isDirtyForm) {
      dispatch(askConfirmAction(clickCreateOutlet()));
    } else {
      dispatch(clickCreateOutlet());
    }
  };

  /**
   * Add outlet: if outlet quota === curent active outlet. Will show payment modal
   * @private
   */
  _onClickAddOutlet = () => {
    this.props.dispatch(clickAddOutlet());
  };

  _createOrAddButtonLabel = () => {
    const { outletSlots, usedOutletSlots } = this.props.data.outletPages.list;
    const { isTrial, isMokaPayUser } = this.props.data;
    if (outletSlots > usedOutletSlots || isTrial || isMokaPayUser) {
      return 'Create Outlet';
    }
    return 'Add Outlet';
  };

  _onClickCreateOrAddButtonLabel = () => {
    const { outletSlots, usedOutletSlots } = this.props.data.outletPages.list;
    const { isTrial, isMokaPayUser } = this.props.data;
    if (!outletSlots) {
      // do nothing
    } else if (outletSlots > usedOutletSlots || isTrial || isMokaPayUser) {
      this._onClickCreateOutlet();
    } else {
      clevertapOutletsList.outletStart();
      this._onClickAddOutlet();
    }
  };
}

ActionBar.propTypes = {
  dispatch: PropTypes.func,
};

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const { is_trial, is_mokapay_user } = state.moka.user.business;
  return {
    data: {
      isDirtyForm: isDirty('outlet')(state),
      outletPages: {
        list: state.outletPages.list,
      },
      isTrial: is_trial,
      isMokaPayUser: is_mokapay_user,
    },
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ActionBar));
